// @flow weak

import React            from 'react';
import {
  Route,
  Redirect,
  Switch
 }                      from 'react-router';
import Images           from '../views/images';
import Home             from '../views/home';
import PrivateRoute     from '../components/privateRoute/PrivateRoute';
import Protected        from '../views/protected';

const MainRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" render={() => (
          <Redirect to="/images"/>
      )}/>
      <Route path="/home" component={Home} />
      <Route exact path="/images" key="/images" component={Images} />
      <Route path="/images/:album" key="/images/:album" component={Images} />
      <Route path="/search/:keyword" key="/search/:keyword" component={Images} />

    </Switch>
  );
};

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/app/routes/MainRoutes.js